import {Component, OnInit, Input} from '@angular/core'
import {Router} from '@angular/router'
// import { Observable } from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription'
import {GalleryService} from '../../../ui-shared/gallery/gallery.service'
import {FolderService} from '../../folder.service'
import {StorageService} from '../../../core/upload/upload.service'
import * as moment from 'moment'

@Component({
  selector: 'app-folder-view-list',
  templateUrl: './folder-view-list.component.html',
  styleUrls: ['./folder-view-list.component.scss'],
})
export class FolderViewListComponent implements OnInit {
  @Input() folder: any
  tablesort: any
  firstsort: boolean = true
  checkall: boolean = false
  items: Array<any> = []
  selectedFiles: Array<any> = []
  subscription: Subscription
  total_messages = {
    flag: 0,
    done: 0,
  }
  sortOn = {
    property: 'name',
    // property: 'sortmessages',
    order: 1,
  }

  constructor(
    public folderService: FolderService,
    public storageService: StorageService,
    public gallery: GalleryService,
    private router: Router
  ) {}

  ngOnInit() {
    window.setInterval(() => {
      this.updateTime()
    }, 60000)
  }

  ngOnChanges() {
    this.refresh()

    if (this.folder && this.folder.subject) {
      this.subscription = this.folder.subject.asObservable().subscribe(() => {
        this.refresh()
      })
    }
  }

  refresh() {
    this.items = []
    this.selectedFiles = []
    this.checkall = false

    if (!this.folder) return

    if (this.folder.filtered_subfolders) {
      for (let i in this.folder.filtered_subfolders) {
        let id = this.folder.filtered_subfolders[i]
        this.items.push({
          name: this.folder.folders[id],
          id: id,
          type: 'folder',
          icon: 'folder_open',
          messages_count: {total: this.folder.subfolders_messages[id] || 0},
          sortmessages: '-' + this.folder.folders[id],
        })
      }
    }

    if (this.folder.filtered_projects) {
      for (let i in this.folder.filtered_projects) {
        let project = this.folder.filtered_projects[i]
        this.items.push({
          name: project.name,
          id: project.id,
          type: 'project',
          icon: 'folder',
        })
      }
    }

    if (this.folder.filtered_files_array) {
      const ICONS = {
        image: 'photo', // photo
        text: 'html5',
        default: 'attach_file',
        video: 'videocam',
      }
      for (let i = 0; i < this.folder.filtered_files_array.length; i++) {
        let item = Object.assign({}, this.folder.filtered_files_array[i])
        if (!item.name) continue
        item.id = item.id || i
        item.dimensions = item.name.match(/\d+x\d+/)
          ? item.name.match(/\d+x\d+/)[0]
          : null
        item.width = item.dimensions ? item.dimensions.split('x')[0] : 0
        item.height = item.dimensions ? item.dimensions.split('x')[1] : 0
        item.previewIndex = i
        // item.moment = moment(item.updated).fromNow().replace('a few seconds ago', 'a minute ago')
        // item.moment = moment(item.updated).calendar()
        item.moment = moment(item.updated).format('lll')
        // item.momenttitle = moment(item.updated).format('MMMM Do YYYY, h:mm:ss a')
        item.momenttitle = moment(item.updated).calendar()
        item.icon = ICONS[item.type.split('/')[0]] || ICONS.default
        item.sortsize = (item.size + '' || '0').padStart(20, '0')
        item.sortwidth =
          (item.width + '').padStart(20, '0') +
          (item.height + '').padStart(20, '0')
        item.sortstatus = item.approved ? '1' : '0'
        if (item.messages_count && !item.approved)
          item.sortmessages = item.messages_count.total
        else item.sortmessages = 0
        item.sortdate = (item.updated + '').padStart(20, '0')

        item.thumbnail = item.type.startsWith('image')
          ? item.path
          : item.fallback
          ? item.fallback
          : null

        this.items.push(item)
      }
    }
    this.sortItems()
  }

  updateTime() {
    if (!this.items) return
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].type !== 'folder') {
        this.items[i].moment = moment(this.items[i].updated).format('lll')
        this.items[i].momenttitle = moment(this.items[i].updated).calendar()
      }
    }
  }

  sort(property) {
    if (this.sortOn.property == property) this.sortOn.order *= -1
    else this.sortOn.property = property
    if (this.firstsort) {
      this.firstsort = false
      this.sortOn.order *= -1
    }
    this.sortItems()
  }

  sortItems() {
    this.items.sort((a, b) => {
      // Make folders appear on top
      if (a.type == 'folder' && this.sortOn.property != 'sortmessages') {
        if (b.type == 'folder')
          return (
            a.name.localeCompare(b.name, undefined, {
              numeric: true,
              sensitivity: 'base',
            }) * (this.sortOn.property == 'name' ? this.sortOn.order : 1)
          )
        return -1
      }

      if (this.sortOn.property == 'sortmessages') {
        a.messages_count = a.messages_count || {total: 0}
        b.messages_count = b.messages_count || {total: 0}
        return (
          (a.messages_count.total - b.messages_count.total) * this.sortOn.order
        )
      }

      return (
        a[this.sortOn.property].localeCompare(
          b[this.sortOn.property],
          undefined,
          {numeric: true, sensitivity: 'base'}
        ) * this.sortOn.order
      )
    })
  }

  selectAll() {
    this.checkall = !this.checkall

    for (let i in this.items)
      if (this.items[i].type !== 'folder') this.items[i].checked = this.checkall

    if (!this.checkall) this.selectedFiles = []
    else this.selectedFiles = this.items.filter(i => i.type !== 'folder')
  }

  onClick(event, item) {
    if (Number.isInteger(item.previewIndex)) {
      event.preventDefault()
      this.gallery.open(item.previewIndex)
      return false
    } else if (item.type == 'folder') {
      event.preventDefault()
      this.router.navigate(['/folder', item.id])
    } else if (item.type == 'project') {
      event.preventDefault()
      this.router.navigate(['/project', item.id])
    }
  }

  onCheck(event, item) {
    event.stopPropagation()
    item.checked = !item.checked
    if (item.checked) this.selectedFiles.push(item)
    else this.selectedFiles = this.selectedFiles.filter(e => e.ref !== item.ref)
    if (this.selectedFiles.length == this.items.length) this.checkall = true
    else this.checkall = false
  }

  onApprove(event, item) {
    // console.log(item)
    event.stopPropagation()
    event.preventDefault()
    item.approved = item.approved !== true
    // console.log(item, item.id, item.approved !== true)
    if (item.id) this.folderService.approveFile(item.id, item.approved)
  }

  downloadSelected() {
    this.storageService.downloadFiles(
      this.selectedFiles,
      this.folderService.current.name
    )
  }

  deleteSelected() {
    this.folderService.deleteFiles(this.selectedFiles)
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe()
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder-view/folder-view-list/folder-view-list.component.ts